<template>
  <header :class="['header', 'header_fixed']">
    <div>
      <div :class="['header__actions', 'header__actions_fixed']">
        <div class="header__wrapper">
          <router-link
            v-if="!isShowErrorScreen"
            class="header__home-link link"
            :to="{ name: 'EligibilityRating' }"
          >
            <img src="@/assets/logos/mse-creditclub-logo.svg" alt="" aria-hidden="true" />

            <h1 class="link__title brand-font_500 u-a11y">
              <span class="link__title-money brand-font_700">MoneySavingExpert</span>
              <span class="link_divider"></span>
              <span class="link__title-credit">Credit Club</span>
            </h1>
          </router-link>
          <HeaderUserActions
            v-if="!isShowErrorScreen"
            class="header__user-actions header__user-actions_desktop"
            @logout="emit('logout')"
          />

          <a
            v-else
            class="header__home-link link"
            href="https://tunirexun.com/creditclub"
            target="_self"
          >
            <img src="@/assets/logos/mse-creditclub-logo.svg" alt="" aria-hidden="true" />

            <h1 class="link__title brand-font_500 u-a11y">
              <span class="link__title-money brand-font_700">MoneySavingExpert</span>
              <span class="link_divider"></span>
              <span class="link__title-credit"
                >Credit Club <span class="link__label">BETA</span></span
              >
            </h1>
          </a>
        </div>
      </div>

      <div class="header__navigation" id="nav">
        <div class="header__wrapper">
          <slot v-if="!isShowErrorScreen" name="navigation" />
        </div>
      </div>
    </div>

    <HeaderOverlayMenu
      :is-opened="store.isOpenMobileMenu && !isShowErrorScreen"
      :routes="routes"
      class="header__overlay-menu"
      @logout="emit('logout')"
    />
  </header>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import HeaderOverlayMenu from '@/components/header/components/HeaderOverlayMenu.vue';
  import HeaderUserActions from '@/components/header/components/HeaderUserActions.vue';
  import { useOutcomeStore, useStore } from '@/stores';
  import { NavigationLink } from '@/types/interfaces';

  const store = useStore();
  const outcomeStore = useOutcomeStore();

  const isShowErrorScreen = computed<boolean>(() => store.isShowErrorScreen);
  const isPositive = computed<boolean>(() => outcomeStore.isPositive);

  const emit = defineEmits<{
    (n: 'logout'): void
  }>();

  defineProps<{
    routes: NavigationLink[]
  }>();
</script>

<style scoped lang="scss">
  .header {
    justify-content: center;
    width: 100%;
    background: $sky-blue-160;
    background-color: white;

    &_fixed {
      min-height: 64px;

      @include new-ms {
        min-height: auto;
      }
    }

    &__wrapper {
      width: 100%;
      max-width: $max-content-width;
      margin: auto;

      @include scale-1 {
        padding: 0 $gutter-scale-1;
      }

      @include scale-2 {
        padding: 0 $gutter-scale-2;
      }

      .link {
        text-decoration: none;

        &__title {
          display: flex;
          flex-direction: column;
          gap: 10px;
          align-items: center;
          font-size: remc(22px);
          line-height: remc(20px);
          color: $brand-primary-100-navy;
          text-align: center;

          @include new-ms {
            flex-direction: row;
            gap: 0;
            text-align: left;
          }
        }

        &__title-money {
          display: block;
          font-size: remc(16px);
          color: $brand-secondary-100-red;

          @include new-ms {
            display: inline-block;
            font-size: remc(22px);
          }
        }

        &__title,
        &__title-money {
          @include new-ms {
            text-align: left;
          }
        }

        &__title-credit {
          display: flex;
          align-items: center;
        }

        &__label {
          display: block;
          padding: 1px 4px 0;
          margin-left: 8px;
          font-size: remc(9px);
          font-weight: 600;
          line-height: remc(13px);
          color: $brand-primary-100-white;
          letter-spacing: 1px;
          background: $brand-primary-100-navy;
          border-radius: 2px;
        }

        &_divider {
          display: none;

          @include new-ms {
            display: block;
            align-self: stretch;
            width: 1px;
            margin: 0 16px;
            background: $brand-primary-100-navy;
          }
        }
      }
    }

    &__overlay-menu {
      @include new-md {
        display: none;
      }
    }

    &__actions {
      padding: 8px 0;

      @include new-ms {
        padding: 16px 0;
      }

      &_fixed {
        top: 0;
        left: 0;
        z-index: 11;
        background-color: white;
      }

      .header__wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }
    }

    &__user-actions {
      @include new-md {
        display: none;
      }

      &_desktop {
        @include new-md {
          display: block;
        }
      }
    }

    &__navigation {
      display: flex;
      justify-content: space-between;

      background: white;
      @include new-ms {
        background: #1c2335;
      }

      .header__wrapper {
        padding: 0;
        @include new-md {
          padding: 0 20px;
        }

        display: flex;
        justify-content: space-between;
        width: 100%;
        max-width: $max-content-width;
        margin: 0 auto;
      }
    }

    &__burger {
      display: block;
      width: 24px;
      height: 24px;
      background-color: transparent;
      background-image: url('@/assets/icons/burger.svg');
      background-repeat: no-repeat;

      @include new-md {
        display: none;
      }
    }
  }
</style>
